<template>
  <ul
    :class="mode === 'small' ? 'gallery gallery--left' : 'gallery'"
  >
    <li
      v-for="(item, index) in galleryItems"
      :key="item.id"
      :class="mode === 'small' ? 'gallery__item gallery__item--small' : 'gallery__item'"
    >
      <Photoswipe
        :gallery-items="galleryItems"
        :gid="gid"
      >
        <template #default="{ openGallery }">
          <button
            :class="mode === 'small' ? 'gallery__image-wrap gallery__image-wrap--small' : 'gallery__image-wrap'"
            @click="openGallery(index)"
          >
            <img
              class="gallery__image"
              :src="item.thumbnail"
            >
          </button>
        </template>
      </Photoswipe>
    </li>
  </ul>
</template>

<script>
import API from '../js/modules/api';
import Photoswipe from './photoswipe/Photoswipe.vue';

export default {
  name: 'Gallery',

  components: { Photoswipe },

  props: {
    id: {
      type: [Number, String],
      required: true,
    },

    resource: {
      type: [Number, String],
      required: true,
    },

    mode: {
      type: [String],
      required: true,
    },
  },

  data: () => ({
    gid: null,
    galleryItems: [],
  }),

  created() {
    this.fetchMedia();
  },

  methods: {
    async fetchMedia() {
      try {
        const { gid, media } = await API()
          .getPropertyMedia(this.id, this.resource);

        this.galleryItems = media;
        this.gid = gid;
      } catch (e) {
        console.error('Unable to fetch images', {
          id: this.id,
          error: e,
        });
      }
    },
  },
};
</script>
